import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';

const NotificationBar = ({ notifications = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSliding, setIsSliding] = useState(false);

  // Cycle through notifications every 10 seconds
  useEffect(() => {
    if (notifications.length === 0) return;

    const cycleInterval = setInterval(() => {
      setIsSliding(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === notifications.length - 1 ? 0 : prevIndex + 1
        );
        setIsSliding(false);
      }, 500); // Wait for slide-out animation to complete
    }, 10000);

    return () => clearInterval(cycleInterval);
  }, [notifications.length]);

  if (notifications.length === 0) return null;

  const currentNotification = notifications[currentIndex];

  return (
    <div className="notification-bar">
      <div className="notification-container">
        <div className={`notification-content ${isSliding ? 'slide-out' : 'slide-in'}`}>
          <Link 
            to={currentNotification.url}
            style={{ 
              color: "white", 
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              textAlign: "center",
              justifyContent: "center"
            }}
          >
            {currentNotification.notification}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotificationBar;